import { useCallback } from 'react';
import toast from "react-hot-toast";
import useEnterKey from 'hooks/useKeydown';
import { useMappedState } from "redux-react-hook";
import { useResendVerificationKeyMutation } from 'services/api/serviceApi';
import styled from 'styled-components';

import Modal from "../../../ui-kit/Modal";
import { Spinner } from '../../ira/ui/Spinner';

const EmailConfirmationModal = ({ isOpen, onClose }) => {

  const [resendVerificationKey, { isLoading }] = useResendVerificationKeyMutation();
  const {
    currentUser
  } = useMappedState(useCallback(state => {
    const currentUser = state.users.usersMap.get(state.users.currentUserId);
    return {
      currentUser: currentUser,
    };
  }, []));

  if (!currentUser || currentUser?.emailVerified) {
    return;
  }



  const handleResendEmail = async () => {
    if (isLoading) {
      return;
    }
    try {
      await resendVerificationKey().unwrap();
      toast.success('Verification email has been sent. Please check your inbox');
    } catch (exc) {
      toast.error('Email has already been sent. Please check your inbox');
    }
  };

  useEnterKey('Enter', handleResendEmail);

  return (

    <Modal isOpen={isOpen} onClose={onClose} canClose={true} classname="email-confirmation-modal">
      <Wrapper>
        To continue, confirm your email
        <Button
          onClick={handleResendEmail}
          disabled={isLoading}
        >
          {isLoading ? 'Sending email' : 'Resend email'}
          {isLoading && <Spinner />}
        </Button>
      </Wrapper>
    </Modal>
  );
};

export default EmailConfirmationModal;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
`;

const Button = styled.div`
  cursor: pointer;
  color: rgba(255, 126, 85, 1);
  border: 1px solid rgba(255, 126, 85, 1);
  font-size: 16px;
  line-height: 20px;
  padding: 6px 12px;
  border-radius: 1000px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-weight: 700;

  :hover {
    background: rgba(255, 126, 85, 1);
    color: white;
  }
`;